import { render, staticRenderFns } from "./chrome.vue?vue&type=template&id=24aa7b3d"
import script from "./chrome.vue?vue&type=script&lang=js"
export * from "./chrome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports